import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { sendContact } from '../API';

export const Footer = () => {

  const [t] = useTranslation('common');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  function openInNewTab(url) {
    window.open(url, '_blank').focus();
  }

  const close = () => {
    setOpen(false);
    setStatus('');
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('sending');
    try {
      const result = await sendContact(form);
      if (!result || result.status !== 200) {
        setStatus('error');
        return;
      }
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        backgroundColor: "#d6d6d8",
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        textAlign: "center"
      }}
    >
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center">
          <Grid
            item xs={12}
          >
            <Typography color="black" variant="h5">
              Bus RT Insights
            </Typography>
          </Grid>
          <Grid
            item xs={12}
          >
            <Typography color="textSecondary" variant="subtitle1">
              <Link to="/licences" style={{ textDecoration: 'none', color: '#59595a' }}>
                {t("footer.license")}
              </Link>
              {` | `}
              <Link to="/privacypolicy" style={{ textDecoration: 'none', color: '#59595a' }}>
                {t("footer.privacy")}
              </Link>
              {` | `}
              <button type="button" className="footer-contact" onClick={() => setOpen(true)}>
                {t("footer.contact")}
              </button>
              <br />
              <a style={{ textDecoration: 'none', color: '#59595a' }} href="https://www.cardinaldatasolutions.com">Cardinal Data Solutions {` ${new Date().getFullYear()}`}</a>
              {/* {` | `}
              <Link to="/enLogin" style={{ textDecoration: 'none', color: '#59595a' }}>
                EN
              </Link> */}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      {open ? (
        <div className="contact-dialog" role="dialog" aria-modal="true" aria-labelledby="contact-dialog-title">
          <button type="button" className="contact-dialog__backdrop" aria-label={t("footer.close")} onClick={close} />
          <form className="contact-dialog__panel agency-request" onSubmit={handleSubmit}>
            <h3 id="contact-dialog-title" className="agency-request__title">{t("footer.title")}</h3>
            <label className="agency-request__field">
              <span>{t("footer.name")}</span>
              <input name="name" type="text" required maxLength={120} value={form.name} onChange={handleChange} />
            </label>
            <label className="agency-request__field">
              <span>{t("footer.email")}</span>
              <input name="email" type="email" required maxLength={160} value={form.email} onChange={handleChange} />
            </label>
            <label className="agency-request__field">
              <span>{t("footer.message")}</span>
              <textarea name="message" rows={4} required maxLength={2000} value={form.message} onChange={handleChange} />
            </label>
            {status === 'sent' ? <p className="agency-request__note agency-request__note--ok">{t("footer.sent")}</p> : null}
            {status === 'error' ? <p className="agency-request__note agency-request__note--err">{t("footer.error")}</p> : null}
            <div className="agency-request__actions">
              <button type="button" className="agency-request__cancel" onClick={close} disabled={status === 'sending'}>
                {t("footer.cancel")}
              </button>
              <button type="submit" className="agency-request__send" disabled={status === 'sending'}>
                {status === 'sending' ? t("footer.sending") : t("footer.send")}
              </button>
            </div>
          </form>
        </div>
      ) : null}
    </Box>
  );
};

export default Footer;